import { ComponentTypeSK, RuleSet, UiComponent } from "@recore-solutions/nstar-lib";

export const applicationUiComponentsToRewrite: {
	[applicationUIComponentSK: number]: Partial<UiComponent<any>>;
} = {};

export const applicationUiComponentsToAdd: UiComponent<any>[] = [];

export const applicationUiComponentsToRemove: UiComponent<any>["applicationUIComponentSK"][] = [];

function rewriteHiddenDesignator(root: UiComponent<string>) {
	return (applicationUiComponent: UiComponent<string>): string => {
		if (
			applicationUiComponent.parentApplicationUIComponentSK === root.applicationUIComponentSK &&
			applicationUiComponent.componentTypeSK === ComponentTypeSK.Group
		) {
			if (applicationUiComponent.longName === "Special Edit") {
				return '[{"++view.specialEditing":{"ne":[true]}}]';
			}
			if (!applicationUiComponent.hiddenDesignator) {
				return '[{"++view.specialEditing":[true]}]';
			}
			const parsed = JSON.parse(applicationUiComponent.hiddenDesignator) as RuleSet;
			parsed.unshift({ "++view.specialEditing": [true] });
			return JSON.stringify(parsed);
		}
		return applicationUiComponent.hiddenDesignator;
	};
}

function rewriteApplicationUIComponent(root: UiComponent<string>) {
	return (applicationUiComponent: UiComponent<string>): UiComponent<string> => {
		const hiddenDesignator = rewriteHiddenDesignator(root)(applicationUiComponent);
		return {
			className: (applicationUiComponent as any).cssClass,
			...applicationUiComponent,
			hiddenDesignator,
			...(applicationUiComponentsToRewrite[applicationUiComponent.applicationUIComponentSK] || {}),
		};
	};
}

function removeApplicationUIComponent(applicationUiComponent: UiComponent<string>): boolean {
	return (
		applicationUiComponentsToRemove.indexOf(applicationUiComponent.applicationUIComponentSK) === -1
	);
}

export function rewriteApplicationUIComponents(
	applicationUiComponents: UiComponent<string>[]
): UiComponent<string>[] {
	const rootUiComponent: UiComponent<string> = applicationUiComponents.find(
		(a) => !a.parentApplicationUIComponentSK
	);
	return [
		...applicationUiComponents
			.filter(removeApplicationUIComponent)
			.map(rewriteApplicationUIComponent(rootUiComponent)),
		...(applicationUiComponents.length ? applicationUiComponentsToAdd : []),
	];
}
